<template>
  <article-layout>
   <h1>Verzonden</h1>
   <router-link to="/">Naar home</router-link>
   <h2>Bedankt voor uw reactie!</h2>
    <p>
      Wij hebben uw reactie ontvangen en nemen zo spoedig mogelijk contact met u op. Dit kan enkele dagen duren.
    </p>
</article-layout>
</template>

<script>
import ArticleLayout from "./ArticleLayout";
export default {
  name: "MailSuccess",
  components: {
        ArticleLayout
    }
}
</script>

<style scoped>
    h1 {
        color: #016F70;
        font-weight: bold;
        line-height: 2;
        font-size: 3em;
        margin-top: 4vh;
        margin-bottom: 0;
    }
    h2 {
        color: #99C5C4;
        font-weight: 500;
        font-size: 1.5em;
        margin-top: 2vh;
        margin-bottom: 0.5vh;
    }
</style>